import { Arg, Entity, Field, Mutation } from '@adornis/baseql/decorators';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity';
import { getCollection } from '@adornis/baseql/server/collections';
import { Message, Recipient } from '@adornis/mails/server/communication';
import { Document } from 'bson';
import { config } from 'config';
import { InsertOneResult } from 'mongodb';
import { mailer } from 'server/mailer';

/**
 * @entity NewsLetterMail
 */
@Entity()
export class NewsLetterMail extends MongoEntity {
  public static _collectionName = 'newsLetterMails';
  public static _class = 'NewsLetterMail';

  @Field(type => String)
  public email!: string;

  @Mutation(() => Boolean)
  public static addEmailToNewsLetter(@Arg('email', type => String) email: string) {
    return async (gqlFields: string) => {
      const collection = await getCollection(this._collectionName);
      const emailDoc = await collection.findOne({ email: email });
      if (emailDoc) {
        console.error('Email already exists in NewsLetter');
        return false;
      }

      await new NewsLetterMail({ email: email }).create();

      return true;
    };
  }

  public static async afterCreate(entity: NewsLetterMail, result: InsertOneResult<Document>) {
    await mailer.sendMail(
      new Message({
        subject: 'New Newsletter Entry',
        html: `
User ${entity.email} signed up to your newsletter!
`,
      }),
      new Recipient(config.get('ADMIN_MAIL')),
    );
  }
}
